<template>
<v-row>
  <v-col cols="12" lg="6">
    <v-row>
      <v-col cols="12" v-if="selectedDocumentType == null && documentTypes.length > 0">
        <v-list>
          <v-list-item
            v-for="documentType in documentTypes"
            :key="documentType.id"
            @click="selectedDocumentType = documentType">
            <v-list-item-content>
              <v-list-item-title v-text="documentType.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-icon>extension</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="selectedDocumentType == null">
        <v-row justify="end">
          <v-btn class="ma-2" @click="addDocumentType" color="success" small dark>
            add profile
            <v-icon right dark>add</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <documentTypeForm
          v-if="selectedDocumentType != null"
          :documentType="selectedDocumentType"
          v-on:done="selectedDocumentType = null"
          v-on:reset="getDocumentTypes"
        ></documentTypeForm>
      </v-col>
    </v-row>
  </v-col>
</v-row>
</template>

<script>
import documentTypeForm from "../../components/DocumentTypeForm.vue";
export default {
  name: "DocumentType",
  components: {
    documentTypeForm
  },
  data() {
    return {
      selectedDocumentType: null,
      documentTypes: []
    };
  },
  methods: {
    getDocumentTypes() {
      this.selectedDocumentType = null;
      this.$http
        .get("api/documenttypes")
        .then(request => {
          this.documentTypes = request.data;
        })
        .catch((e) => {
          this.$root.$children[0].$emit("display-error", "2600", e);
        });
    },
    addDocumentType() {
      this.documentTypes.push({
        name: "",
        fields: [{ name: "", type: 0 }]
      });
      this.selectedDocumentType = this.documentTypes[
        this.documentTypes.length - 1
      ];
    }
  },
  mounted() {
    this.getDocumentTypes();
  }
};
</script>